/**
 * Compare to delivery slot strings to determine if they have the same 
 * delivery slot identifier (ignoring any dynamic values) 
 * @param slotA First slot to compare
 * @param slotB Second slot to compare
 * @returns Boolean result
 */
export const slotsMatch = (slotA : string, slotB: string ) => {   
    return slotA?.split('_')[0] === slotB?.split('_')[0]
}